import { RefObject, useEffect, useState } from "react";
import Validator from "../../validator";

const useValidator = ( refs: RefObject<HTMLInputElement>[] ) => {

  const validator = new Validator([]);

  useEffect( () => {

    // Add targets to validator if component gets mounted
    const targets = refs
      .filter( ref => ref.current )
      .map( ref => ref.current ) as HTMLInputElement[];

    validator.add( targets );

    return () => {

      // Destroy validator if component gets unmounted
      validator.destroy();
    }
  }, [] );

  return validator;
}

export default useValidator;
